import { render, staticRenderFns } from "./processKpsrNonRiskbook.vue?vue&type=template&id=26cc9f3a"
import script from "./processKpsrNonRiskbook.vue?vue&type=script&lang=js"
export * from "./processKpsrNonRiskbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26cc9f3a')) {
      api.createRecord('26cc9f3a', component.options)
    } else {
      api.reload('26cc9f3a', component.options)
    }
    module.hot.accept("./processKpsrNonRiskbook.vue?vue&type=template&id=26cc9f3a", function () {
      api.rerender('26cc9f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processKpsrNonRiskbook.vue"
export default component.exports